@if (updatedDate) {
  <div class="text-muted small">
    @if (updatedBy) {
      <span>Last edited by {{ updatedBy }} on </span>
    }
    @if (!updatedBy) {
      <span>Last edited on </span>
    }
    {{ updatedDate | date:'MM-dd-yyyy' }} at {{ updatedDate | date:'h:mm a' }}
  </div>
}
